<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="ded"> </p>
<p class="ded"><span class="epub-i">For Windop. And in memory of my grandmother, who wanted to avoid the shame and died while I was completing the last pages of the manuscript.</span></p>
<p class="ded"> </p>
<p class="ded">Any similarity between existing people and certain characters in this book is due solely to insight into human nature.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?6ec9e86b